import React, {FunctionComponent, useCallback, useContext, useEffect, useState} from 'react';
import "./AcceptedSignaturePage.scss"
import {InvoiceContext} from "../../context/InvoiceContext";
import {PageContext} from "../../context/PageContext";
import pdfIcon from "../../assets/icons/file-pdf-duotone.svg";
import {Button} from "../../components/ui-components/Button/Button";
import {PaymentModal} from "../../components/PaymentModal/PaymentModal";
import {FullPagePreloader} from "../../components/FullPagePreloader/FullPagePreloader";
import {MiddlePagePreloader} from "../../components/MiddlePagePreloader/MiddlePagePreloader";

export const AcceptedSignaturePage: FunctionComponent = () => {
    const invoice = useContext(InvoiceContext);
    const pdfUrl = useContext(PageContext).pageData.pdf_url;
    const pageContext = useContext(PageContext);
    const [isPaymentModalVisible, setPaymentModalVisible] = useState<boolean>(false);

    useEffect(() => {
        if (pageContext.isPaymentAcceptedSignaturePage()) {
            onClickPayNow();
        }
    }, [pageContext.isPaymentAcceptedSignaturePage()]);


    const isPaymentAvailable = useCallback(() => {
        return invoice.is_payment_available && pageContext.isAcceptedSignaturePage();
    }, [pageContext, invoice]);

    const onClickPayNow = useCallback(() => {
        setPaymentModalVisible(true);
    }, [setPaymentModalVisible]);

    const onClosePaymentModal = useCallback(() => {
        setPaymentModalVisible(false);
    }, [setPaymentModalVisible]);

    return (
        <div className='full-page-section accepted-signature-page'>
            <FullPagePreloader/>
            <MiddlePagePreloader/>
            <img src={pdfIcon} alt="file-pdf" className="full-page-icon"/>
            <h1>{invoice.invoice_title} has been accepted.</h1>
            <h3>Download the <a href={pdfUrl} download={true} target={'_blank'}>PDF</a></h3>

            {isPaymentAvailable() && <div>
                <Button onClick={onClickPayNow} className="payment-button green-button">Pay Now</Button>
            </div>}
            {isPaymentModalVisible && <PaymentModal onCloseModal={onClosePaymentModal}/>}
        </div>
    );
};
